import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType } from 'src/targeting/types';
import { OperatingSystemType } from 'src/kameleoonData/types';
import { ConditionDataType, ICondition } from './types';

export class OperatingSystem implements ICondition {
  private operatingSystem?: OperatingSystemType | null;

  constructor({ os }: ConditionDataType) {
    this.operatingSystem = os;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const operatingSystemData = targetingData?.[KameleoonData.OperatingSystem];

    if (operatingSystemData) {
      const { operatingSystem } = operatingSystemData;

      return Ok(operatingSystem === this.operatingSystem);
    }

    return Ok(false);
  }
}
